/** Contenido de la oferta de Baby Shower Dulce Recuerdo. */
export const offerIncludedItems = [
  { label: '30 juegos imprimibles', isBonus: false },
  { label: '50 dinámicas en movimiento', isBonus: true },
  { label: 'Guía de la organizadora', isBonus: true },
  { label: 'Tres planes de juegos', isBonus: true },
  { label: 'Checklist de preparación e impresión', isBonus: true },
  { label: 'Versiones rosa y celeste incluidas', isBonus: false },
]

/**
 * Bonos adicionales de la oferta. No se muestran mientras la lista esté vacía.
 * Agregá aquí solo bonos confirmados, por ejemplo: { label: 'Nombre del bono' }.
 */
export const offerExtraBonuses: { label: string }[] = []

/** URL del mockup completo del producto. Vacío = placeholder. */
export const offerMockupImage = 'https://cdn.magicpatterns.com/uploads/fjLjrCHKSRYJafeqDeE3rD/Kit_de_Baby_Shower_Dulce_Recuerdo.png'
